import apiRequest from './apiRequest';

/** Updates Stripe subscription seat quantity during workspace free trial (trial end unchanged). */
export default async function postOrganizationTrialingSeats(
  organizationID: string,
  totalSeats: number,
) {
  return apiRequest<{ seatsPurchased: number }>(
    'user',
    `/organizations/${organizationID}/subscription/seats`,
    {
      method: 'POST',
      body: JSON.stringify({ totalSeats }),
    },
  );
}
